import { CommissionsTabs } from "globalConstants";
import { hasPermissions } from "helpers";

export const tabs = [
	{
		path: CommissionsTabs.SourceFiles.name,
		name: CommissionsTabs.SourceFiles.displayName,
		requiredPermissions: false,
	},
];

export const getCommissionsTabsPaths = () =>
	tabs
		.filter(tab => hasPermissions(tab.requiredPermissions))
		.map(tab => tab.path);
